import { FC } from 'react';
import Select, { components, DropdownIndicatorProps } from 'react-select';
import { ChevronDownIcon as ChevronDownComponent } from '@features/ui/icons';
import { TOption } from '@src/types';

const DropdownIndicator = (props: DropdownIndicatorProps) => {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDownComponent className={'mr-1'} />
    </components.DropdownIndicator>
  );
};

interface MultiSelectProps {
  options: TOption[];
  placeholder?: string;
  value?: (string | number)[] | null;
  error?: boolean;
  onChange?: (value: (string | number)[]) => void;
  id?: string;
}
export const MultiSelect: FC<MultiSelectProps> = ({
  options,
  placeholder,
  value,
  error,
  onChange,
  id,
}) => {
  const customStyles = {
    control: (base: any) => ({
      ...base,
      backgroundColor: 'transparent',
      borderColor: error ? '#ef4444' : '#C6C6C6',
      borderWidth: '1px',
      borderRadius: '3px',
      minHeight: '38px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#C6C6C6',
      },
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: '#171717',
      color: 'white',
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: 'white',
    }),
    singleValue: (base: any) => ({
      ...base,
      color: '#ccc',
    }),
    placeholder: (base: any) => ({
      ...base,
      color: '#A1A1A1FF',
    }),
    dropdownIndicator: (base: any) => ({
      ...base,
      color: '#888',
      padding: '0 8px',
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: '#414141FF',
      zIndex: 20,
      paddingLeft: 4,
      paddingRight: 4,
      borderRadius: 6,
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isFocused ? '#535353' : '#414141FF',
      color: '#ccc',
      padding: '8px 12px',
      paddingTop: 6,
      paddingBottom: 6,
      paddingRight: 8,
      paddingLeft: 8,
      borderRadius: 6,
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#333',
      },
    }),
    indicatorSeparator: (base: any) => ({
      ...base,
      width: 0,
    }),
  };

  const selectedOptions = options.filter((opt) => value?.includes(opt.value));

  return (
    <Select
      isMulti
      components={{
        // @ts-ignore
        DropdownIndicator,
      }}
      id={id}
      isSearchable={false}
      options={options}
      placeholder={placeholder ?? 'Select'}
      styles={customStyles}
      value={selectedOptions}
      onChange={(selected) => {
        const values = (selected as TOption[]).map((opt) => opt.value);

        onChange?.(values);
      }}
    />
  );
};
